<template>
  <q-item-section :avatar="avatar" :top="top" :side="side">
    <slot />
  </q-item-section>
</template>

<script>
export default {
  name: 'RItemSection',
  props: {
    avatar: Boolean,
    top: Boolean,
    side: Boolean,
  },
};
</script>
